module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [(_vm.props) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('div', {
    staticClass: "pages-home__container"
  }, [_c('HeadMainBar', {
    attrs: {
      "props": _vm.props.acf.header
    }
  })], 1), _c('div', {
    staticClass: "pages-home__parallax-1"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.7),
      expression: "0.7"
    }],
    staticClass: "pages-home__parallax-mask1",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.parallax1.background_image + ')'
    })
  }), _c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.parallax1
    }
  })], 1), _c('div', {
    staticClass: "pages-home__main-content"
  }, [_c('div', {
    staticClass: "pages-home__ourdoc"
  }, [_c('div', {
    staticClass: "pages-home__main-content-container"
  }, [(_vm.props.acf.meet_the_docs_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.meet_the_docs_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "homedoc_outer clearfix"
  }, [_c('div', {
    staticClass: "homedoc_list"
  }, [(_vm.props.acf.docs_list) ? _c('div', {
    staticClass: "docslider clearfix"
  }, [_c('swiper', {
    ref: "swiperThumbs",
    staticClass: "swiper gallery-thumbs",
    attrs: {
      "options": _vm.swiperOptionThumbs
    }
  }, _vm._l((_vm.props.acf.docs_list), function(DocTour, i) {
    return _c('swiper-slide', {
      class: 'slide-' + i
    }, [_c('div', {
      staticClass: "docbgimg",
      style: ({
        backgroundImage: 'url(' + DocTour.image + ')'
      })
    })])
  })), _c('swiper', {
    ref: "swiperTop",
    staticClass: "swiper gallery-top",
    attrs: {
      "options": _vm.swiperOptionTop
    }
  }, [_vm._l((_vm.props.acf.docs_list), function(DocTour, j) {
    return _c('swiper-slide', {
      class: 'slide-' + j
    }, [_c('div', {
      staticClass: "innerdocouter clearfix"
    }, [_c('div', {
      staticClass: "innerdocleft"
    }, [_c('div', {
      staticClass: "imgdocc",
      style: ({
        backgroundImage: 'url(' + DocTour.image + ')'
      })
    })]), _c('div', {
      staticClass: "innerdocright"
    }, [_c('h4', {
      domProps: {
        "innerHTML": _vm._s(DocTour.title)
      }
    }), _c('div', {
      staticClass: "content_doc",
      domProps: {
        "innerHTML": _vm._s(DocTour.content)
      }
    }), _c('a', {
      staticClass: "readbtn",
      attrs: {
        "aria-label": ""
      },
      on: {
        "click": function($event) {
          _vm.callGa(j)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(DocTour.read_more_text)
      }
    }), _c('i', {
      staticClass: "fa fa-arrow-circle-o-right"
    })])])])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev",
      "aria-label": "Slider Previous"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next",
      "aria-label": "Slider Next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()])])])]), _c('div', {
    staticClass: "pages-home__main-content-container"
  }, [_c('div', {
    staticClass: "pages-home__section-1"
  }, [_c('div', {
    staticClass: "pages-home__left",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.background_image + ')'
    })
  }), _c('div', {
    staticClass: "pages-home__right"
  }, [_c('TextBox', {
    staticClass: "pages-home__right1",
    attrs: {
      "props": _vm.props.acf.welcome
    }
  }), _c('TextBox', {
    staticClass: "pages-home__right2",
    attrs: {
      "props": _vm.props.acf.subtitle
    }
  }), _c('TextBox', {
    staticClass: "pages-home__right3",
    attrs: {
      "props": _vm.props.acf.subtitle_body
    }
  })], 1)]), _c('div', {
    staticClass: "pages-home__section-2"
  }, [_c('div', {
    staticClass: "pages-home__section-top"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.subtitle2
    }
  })], 1), _c('div', {
    staticClass: "pages-home__section-bottom"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.subtitle_body2
    }
  })], 1), _c('div', {
    staticClass: "pages-home__treatment"
  }, [_c('img', {
    staticClass: "pages-home__treatment-logo",
    attrs: {
      "src": _vm.props.acf.treatment_logo,
      "alt": "Merrick Orthodontics"
    }
  })]), _c('div', {
    staticClass: "pages-home__button"
  }, [_c('router-link', {
    attrs: {
      "to": "/about-us"
    }
  }, [_vm._v(_vm._s(_vm.props.acf.button))])], 1)])])]), _c('div', {
    staticClass: "pages-home__main-content"
  }, [_c('div', {
    staticClass: "pages-home__cta-banner"
  }, [_c('CustomCTABanner', {
    attrs: {
      "props": _vm.props.acf.invisalign_video
    }
  })], 1)]), _c('div', {
    staticClass: "pages-home__main-content"
  }, [_c('div', {
    staticClass: "pages-home__section-3"
  }, [_c('div', {
    staticClass: "pages-home__section-3-top"
  }, [_c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.section_3
    }
  }), _c('BlockRepeater', {
    attrs: {
      "props": _vm.props.acf.section_3
    }
  })], 1)]), _c('div', {
    staticClass: "pages-home__section-4"
  }, [_c('div', {
    staticClass: "pages-home__section-4-top"
  }, [_c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.section_4
    }
  }), _c('BlockLinkRepeater', {
    attrs: {
      "props": _vm.props.acf.section_4
    }
  })], 1)])]), _c('div', {
    staticClass: "pages-home__parallax-2"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.7),
      expression: "0.7"
    }],
    staticClass: "pages-home__parallax-mask2",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.parallax2.background_image + ')'
    })
  }), _c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.parallax2
    }
  })], 1), _c('div', {
    staticClass: "pages-home__testimonials"
  }, [_c('div', {
    staticClass: "pages-home__testimonials-overlay"
  }), _c('div', {
    staticClass: "pages-home__testimonials-left"
  }, [_c('SliderTest', {
    attrs: {
      "props": _vm.props.acf.testimonial
    }
  })], 1), _c('div', {
    staticClass: "pages-home__testimonials-right"
  }, [_c('div', {
    staticClass: "pages-home__testimonials-right-image",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.background_image2 + ')'
    })
  })])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58f90a08","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 601
// module chunks = 1